import React from 'react'
import ITProductsCarousel from './ITProductsCarousel'

const ITProductsCarouselMain = () => {
    return (
        <>
            <section className="main-wrap caro-first" style={{ padding: "0px" }}>
                <div className="container-fluid">
                    <h2 className="title1 lower-pro">IT Products</h2>
                    <ITProductsCarousel/>
                </div>
            </section>

        </>
    )
}

export default ITProductsCarouselMain